import env from '@/util/env';
import { loadSentry } from './api';

export async function initSentry() {
  if (!env.SENTRY_ENABLED) {
    return;
  }

  const Sentry = await loadSentry();
  Sentry.init({
    dsn: 'https://9280b5b8d501d6dc51d597142721ed99@o4510068029849600.ingest.de.sentry.io/4510068062879824',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.zodErrorsIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/px\.sandvik\.com\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    environment: env.NAME,
    release: import.meta.env.VITE_SENTRY_RELEASE || 'unknown-sam-web',
  });
}
